var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCanOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.222,
    height: 16,
    viewBox: "0 0 14.222 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-can-outline",
    d: "M8.444,3v.889H4V5.667h.889V17.222A1.778,1.778,0,0,0,6.667,19h8.889a1.778,1.778,0,0,0,1.778-1.778V5.667h.889V3.889H13.778V3H8.444M6.667,5.667h8.889V17.222H6.667V5.667M8.444,7.444v8h1.778v-8H8.444m3.556,0v8h1.778v-8Z",
    transform: "translate(-4 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanOutline);
export default __webpack_public_path__ + "static/media/trash_can_outline.271d12ed0e5608deb7c98058ef0a8817.svg";
export { ForwardRef as ReactComponent };